import React, { useEffect, useMemo, useState } from 'react';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import { fetchAllLogsInRange, aggregateLogsByDate } from '../services/logService';

export default function ProductionTrendChart({ startDate, endDate, productId }) {
  const [loading, setLoading] = useState(false);
  const [series, setSeries] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const logs = await fetchAllLogsInRange(200, '', '', '');
      const aggregated = aggregateLogsByDate(logs, productId || null, startDate, endDate);
      const points = Object.keys(aggregated).sort().map(d => ({ x: d, y: aggregated[d] }));
      setSeries(points);
    } catch (e) {
      console.error('Error fetching trend data', e);
      setSeries([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, startDate, endDate]);

  const chartData = useMemo(() => ({
    labels: series.map(p => p.x),
    datasets: [{
      label: productId ? 'Daily Production (selected product)' : 'Daily Production (All Products)',
      data: series.map(p => p.y),
      tension: 0.25,
      borderColor: '#007bff',
      backgroundColor: 'rgba(0, 123, 255, 0.25)',
      borderWidth: 2,
      pointRadius: 3,
      pointBackgroundColor: '#007bff',
    }],
  }), [series, productId]);

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
      tooltip: { mode: 'index', intersect: false },
    },
    scales: {
      x: { type: 'time', time: { unit: 'day', tooltipFormat: 'yyyy-MM-dd' } },
      y: { beginAtZero: true, title: { display: true, text: 'Quantity' } },
    },
  }), []);

  return (
    <div className="card mb-4">
      <div className="card-body">
        {loading && <div className="text-muted small mb-2">Loading chart…</div>}
        <div style={{ height: 320 }}>
          {series.length === 0 && !loading ? (
            <div className="text-muted">No data for the selected filters.</div>
          ) : (
            <Line data={chartData} options={options} />
          )}
        </div>
      </div>
    </div>
  );
}
